export const getFirstContact = (contacts: string[]): string => {
  if (contacts == null || contacts.length === 0) {
    return '';
  }
  return contacts[0];
};

export const getOtherContacts = (contacts: string[]): string[] => {
  const otherContacts: string[] = [];

  if (contacts?.length > 1) {
    for (let i = 1; i < contacts.length; i += 1) {
      otherContacts.push(contacts[i]);
    }
  }
  return otherContacts;
};
